import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const icon = name => m("i", {
  className: `icon ${name}`,
  "aria-hidden": "true"
});
const JOB_NAMES = {
  street_cleaner: 'Operator zamiatarki',
  shop_worker: 'Pracownik sklepu Żabka',
  park_maintenance: 'Kosiarz miejski',
  dock_worker: 'Operator portowy',
  road_maintenance: 'Pracownik utrzymania dróg',
  courier: 'Kurier',
  bus: 'Kierowca autobusu',
  garbage: 'Pracownik komunalny',
  food_delivery: 'Dostawca jedzenia',
  warehouse: 'Pracownik magazynu',
  taxi: 'Taksówkarz',
  trucking: 'Kierowca ciężarówki',
  truck_logistics: 'Logistyka ciężarowa',
  transport_control: 'Inspekcja transportu',
  fire_incident: 'Strażak',
  bp_restock: 'Dostawca paliwa BP Ultimate',
  bp_intercity: 'Transport międzymiastowy BP',
  miner: 'Górnik',
  mining: 'Górnik',
  forestry: 'Drwal',
  construction: 'Pracownik budowlany',
  roadside: 'Pomoc drogowa SARA',
  mechanic: 'Mechanik',
  agriculture: 'Rolnik'
};
const jobName = code => JOB_NAMES[String(code || '').toLowerCase()] || String(code || 'Nieznana praca').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
class NovaPlayerPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.profile = null;
    this.error = null;
    this.loading = true;
    this.forumUsername = String(m.route.param('username') || '').trim();
    this.requestProfile();
  }
  oncreate() {
    window.scrollTo(0, 0);
  }
  view() {
    return m("div", {
      className: "NovaPlayerPage"
    }, m("div", {
      className: "container NovaPlayerLayout"
    }, m("aside", {
      className: "NtSiteSidebar NovaPlayerSidebar"
    }, m("div", {
      className: "NtSiteSidebar-title"
    }, m("span", null, "NOVA COMMUNITY"), m("strong", null, "Forum")), m("nav", null, m(Link, {
      href: "/"
    }, icon('far fa-comment'), m("span", null, "Wszystkie dyskusje")), m(Link, {
      href: "/tags"
    }, icon('fas fa-th-large'), m("span", null, "Tagi")), m(Link, {
      href: "/t/ogloszenia"
    }, icon('fas fa-bullhorn'), m("span", null, "Og\u0142oszenia")), m(Link, {
      href: "/t/aktualizacje"
    }, icon('fas fa-star'), m("span", null, "Aktualizacje")), m(Link, {
      href: "/t/pomoc-techniczna"
    }, icon('fas fa-wrench'), m("span", null, "Pomoc techniczna")), m(Link, {
      href: "/t/rozgrywka"
    }, icon('fas fa-gamepad'), m("span", null, "Rozgrywka")), m(Link, {
      href: "/t/frakcje-i-organizacje"
    }, icon('fas fa-users'), m("span", null, "Frakcje i organizacje")), m(Link, {
      href: "/t/gielda"
    }, icon('fas fa-tag'), m("span", null, "Gie\u0142da"))), m("div", {
      className: "NtSiteSidebar-shortcuts"
    }, m(Link, {
      href: "/serwer"
    }, icon('fas fa-server'), " Serwer"), m(Link, {
      href: "/ranking"
    }, icon('fas fa-trophy'), " Ranking"), m(Link, {
      href: "/novaid"
    }, icon('fas fa-id-card'), " NovaID"))), m("main", {
      className: "NovaPlayerMain"
    }, m("header", {
      className: "NovaPlayerPage-title"
    }, m("div", {
      className: "NovaPlayerPage-heading"
    }, m("span", null, icon('fas fa-id-card')), m("div", null, m("small", null, "NOVA ID \u2022 DANE GRY"), m("h1", null, "Profil gracza"))), m("span", {
      className: "NovaPlayerPage-user"
    }, this.forumUsername)), this.content())));
  }
  requestProfile() {
    if (!this.forumUsername) {
      this.error = 'user-unavailable';
      this.loading = false;
      return;
    }
    const configuredBase = app.forum.attribute('novaApiUrl') || 'https://api.novatruck-rp.pl/v1';
    const base = String(configuredBase).replace(/\/+$/, '');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    fetch(`${base}/flarum/player-by-username/${encodeURIComponent(this.forumUsername)}`, {
      headers: {
        Accept: 'application/json'
      },
      signal: controller.signal
    }).then(response => {
      if (!response.ok) {
        if (response.status === 403) throw new Error('private');
        if (response.status === 404) throw new Error('not-linked');
        throw new Error(`http-${response.status}`);
      }
      return response.json();
    }).then(data => {
      this.profile = data;
      this.loading = false;
      m.redraw();
    }).catch(error => {
      this.error = error && error.name === 'AbortError' ? 'timeout' : error.message || 'unavailable';
      this.loading = false;
      m.redraw();
    }).finally(() => {
      window.clearTimeout(timeout);
    });
  }
  content() {
    if (this.loading) return m("div", {
      className: "NovaProfile-loading"
    }, m(LoadingIndicator, null));
    if (this.error) {
      const messages = {
        private: 'Profil gracza jest prywatny.',
        'not-linked': 'To konto forum nie jest jeszcze połączone z kontem gry.',
        timeout: 'API gry nie odpowiedziało w ciągu 15 sekund.',
        'user-unavailable': 'Nie udało się załadować użytkownika forum.'
      };
      return m("div", {
        className: "NovaProfile-empty"
      }, messages[this.error] || 'Dane gry są chwilowo niedostępne.');
    }
    if (!this.profile || !Array.isArray(this.profile.characters) || !this.profile.characters.length) {
      return m("div", {
        className: "NovaProfile-empty"
      }, "Gracz nie ma jeszcze utworzonej postaci.");
    }
    const list = value => Array.isArray(value) ? value : [];
    return m("div", {
      className: "NovaProfile"
    }, this.profile.characters.map(c => {
      const vehicles = list(c.vehicles);
      const properties = list(c.properties);
      const businesses = list(c.businesses);
      const organizations = list(c.organizations);
      const jobs = list(c.job_mastery);
      const licenses = list(c.licenses);
      return m("section", {
        className: "NovaProfile-card"
      }, m("header", null, m("span", {
        className: "NovaProfile-characterIcon"
      }, icon('fas fa-user')), m("div", null, m("small", null, "AKTYWNA POSTA\u0106"), m("h2", null, c.first_name, " ", c.last_name)), m("span", {
        className: "NovaProfile-level"
      }, "Poziom ", c.level, " \xB7 Reputacja ", c.reputation)), m("div", {
        className: "NovaProfile-stats"
      }, m("div", null, icon('fas fa-car'), m("span", null, m("b", null, vehicles.length), m("small", null, "Pojazdy"))), m("div", null, icon('fas fa-home'), m("span", null, m("b", null, properties.length), m("small", null, "Nieruchomo\u015Bci"))), m("div", null, icon('fas fa-store'), m("span", null, m("b", null, businesses.length), m("small", null, "Biznesy"))), m("div", null, icon('fas fa-users'), m("span", null, m("b", null, organizations.length), m("small", null, "Organizacje")))), m("h3", null, icon('fas fa-car-side'), " Pojazdy"), m("div", {
        className: "NovaProfile-grid"
      }, vehicles.map(v => m("article", null, m("strong", null, v.model_name), m("span", null, v.plate), m("small", null, Number(v.mileage_km || 0).toLocaleString('pl-PL'), " km \xB7 paliwo ", v.fuel, "%")))), m("h3", null, icon('fas fa-briefcase'), " Kariera i prace"), m("div", {
        className: "NovaProfile-grid"
      }, jobs.map(j => m("article", null, m("strong", null, jobName(j.job_code)), m("span", null, j.completed_runs, " uko\u0144czonych zlece\u0144"), m("small", null, "Reputacja ", j.reputation, " \xB7 najlepsza jako\u015B\u0107 ", j.best_quality, "%")))), properties.length ? m('[', null, m("h3", null, icon('fas fa-home'), " Nieruchomo\u015Bci"), m("div", {
        className: "NovaProfile-grid"
      }, properties.map(p => m("article", null, m("strong", null, p.property_code), m("span", null, p.country_code))))) : null, businesses.length ? m('[', null, m("h3", null, icon('fas fa-store'), " Biznesy"), m("div", {
        className: "NovaProfile-grid"
      }, businesses.map(b => m("article", null, m("strong", null, b.name), m("span", null, b.business_type))))) : null, licenses.length ? m('[', null, m("h3", null, icon('fas fa-id-badge'), " Licencje"), m("div", {
        className: "NovaProfile-grid"
      }, licenses.map(l => m("article", null, m("strong", null, l.license_code), m("span", null, l.revoked_at ? 'Cofnięta' : 'Aktywna'))))) : null, organizations.length ? m('[', null, m("h3", null, icon('fas fa-users'), " Organizacje"), m("div", {
        className: "NovaProfile-grid"
      }, organizations.map(o => m("article", null, m("strong", null, o.name), m("span", null, o.rank_name))))) : null);
    }));
  }
}
class NovaDelegatedControlPage extends Page {
  tab = 'overview';
  data = null;
  error = '';
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  endpoint() {
    return `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/control`;
  }
  async load() {
    this.loading = true;
    this.error = '';
    try {
      this.data = await app.request({
        method: 'GET',
        url: `${this.endpoint()}?section=${this.tab}`
      });
    } catch (e) {
      this.error = e?.response?.errors?.[0]?.detail || 'Nie masz dostępu do tego modułu.';
    }
    this.loading = false;
    m.redraw();
  }
  choose(tab) {
    this.tab = tab;
    this.load();
  }
  view() {
    const rows = this.tab === 'users' ? this.data?.users || [] : this.tab === 'forum' ? this.data?.tags || [] : this.tab === 'mta' ? this.data?.accounts || [] : this.tab === 'audit' ? this.data?.logs || [] : [];
    return m("div", {
      className: "NovaDelegate"
    }, m("header", null, m("small", null, "NOVA OPERATIONS"), m("h1", null, "Panel moderatora"), m("p", null, "Widzisz wy\u0142\u0105cznie modu\u0142y przyznane przez administratora.")), m("nav", null, [['overview', 'Pulpit'], ['users', 'Użytkownicy'], ['forum', 'Forum'], ['mta', 'MTA'], ['audit', 'Audyt']].map(x => m("button", {
      className: this.tab === x[0] ? 'active' : '',
      onclick: () => this.choose(x[0])
    }, x[1]))), this.loading ? m(LoadingIndicator, null) : this.error ? m("div", {
      className: "NovaProfile-empty"
    }, this.error) : this.tab === 'overview' ? m("div", {
      className: "NovaDelegate-stats"
    }, Object.entries(this.data?.forum || {}).map(_ref => {
      let [k, v] = _ref;
      return m("article", null, m("small", null, k), m("strong", null, String(v)));
    })) : m("div", {
      className: "NovaDelegate-list"
    }, rows.map(row => m("article", null, m("strong", null, row.username || row.name || row.action || `#${row.id}`), m("small", null, row.email || row.description || row.module || '')))));
  }
}
app.initializers.add('novatruck-nova-profile', () => {
  app.routes['user.novaPlayer'] = {
    path: '/u/:username/gracz',
    component: NovaPlayerPage
  };
  app.routes['novatruck.control'] = {
    path: '/nova-control',
    component: NovaDelegatedControlPage
  };
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (user) items.add('novaPlayer', m(LinkButton, {
      href: app.route('user.novaPlayer', {
        username: user.slug()
      }),
      icon: "fas fa-truck"
    }, "Profil gracza"), 85);
  });
});